import { Avatar, Button, Container, Drawer, Hidden } from "@material-ui/core";
import { GoogleOAuthProvider,GoogleLogin,googleLogout,useGoogleLogin } from '@react-oauth/google';
import { useState,useEffect } from 'react';
const { OAuth2Client } = require('google-auth-library')


function AdminLogin_new(props) {
    const clientID="487513725146-23cg56616hug2bj6ujk7jfon27575eet.apps.googleusercontent.com"
    const client = new OAuth2Client(clientID)
    const [name,setName]=useState("");
    const [email,setEmail]=useState("");
    const [photo,setPhoto]=useState("");
    const [idToken,setIdToken]=useState("");
    const [localStore,setLocalStore]=useState("");
    const [isAuthenticated,setIsAuthenticated]=useState(false);
    const [showUI,setShowUI]=useState(false);
    const {authenticationHandler,security,apiDomain}=props;
    useEffect(()=>{
        const tmpLocalStore=localStorage.getItem('google_data');
        console.log("getting data from localstorage");
        if(tmpLocalStore && tmpLocalStore!==''){
            //console.log(JSON.parse(tmpLocalStore));
           setLocalStore(JSON.parse(tmpLocalStore));
        }
    },[]);

    useEffect(()=>{
        console.log({localStore});
        if(localStore.isAuthenticated){
            setIdToken(localStore.idToken);
            setName(localStore.name);
            setEmail(localStore.email);
            setPhoto(localStore.photo);
            setIsAuthenticated(localStore.isAuthenticated);
        }else{
            
        }
      },[localStore])

      useEffect(()=>{
        saveCredentials();
        if(isAuthenticated){
            authenticationHandler({isAuthenticated:true,idToken:idToken,email:email});
        }else{
            authenticationHandler({isAuthenticated:false,idToken:"",email:""});
        }
      },[isAuthenticated])

      
    const saveCredentials=()=>{
        const saveValue={
            idToken:idToken,
            name:name,
            email:email,
            photo:photo,
            isAuthenticated:isAuthenticated
        }
        console.log('saving local storage');
        console.log({saveValue});
        localStorage.setItem('google_data',JSON.stringify(saveValue));
    }
    const decodeCredential=async (token)=>{
        const ticket = await client.verifyIdToken({
            idToken: token,
            audience: clientID,
        })
        const userInfo=ticket.payload;
        //console.log(userInfo);
        
        console.log("old token______");
        console.log(token);
        //const  newtoken=await client.getAccessToken((err)=>{
        //    console.log(err)
        //});
        //console.log("new token______");
        //console.log({newtoken});
       const rValue={profileObj:userInfo,tokenObj:{id_token:token}};
        googleLoginResponse(rValue);
    }
   

    const googleLoginResponse = (response) => {
        if(response.profileObj){
            setName(response.profileObj.name);
            setEmail(response.profileObj.email);
            setPhoto(response.profileObj.picture);
            setIdToken(response.tokenObj.id_token);
            setIsAuthenticated(true);
            //authenticationHandler({isAuthenticated:true,idToken:response.tokenObj.id_token,email:response.profileObj.email});
            setShowUI(false);
        }
      }
      const googleLogoutResponse = (response) => {
        setName("");
        setEmail("");
        setPhoto("");
        setIdToken("");
        setIsAuthenticated(false);
        //authenticationHandler({isAuthenticated:false,idToken:"",email:""});
      }

      const logoutGoogle=()=>{
        googleLogout();
        googleLogoutResponse();
      }
      const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
          return;
        }
        setShowUI(open);
      };
      const reloadSecurity = (response) => {
        let params=`/members/admin/reloadsecurity/`;
        let method="get";
        let head={"id_token":idToken};
        let body=null;
        fetch(apiDomain+params,{"headers":head,method:method,body:body})
        .then(res => res.text())
        .then(res => {
          alert("done");
        } )
        .catch((error)=>{
          alert("error"+error.message);
        });

      }
      const logout = (response) => {
        let params=`/members/admin/logout/`;
        let method="get";
        let head={"id_token":idToken};
        let body=null;
        fetch(apiDomain+params,{"headers":head,method:method,body:body})
        .then(res => res.text())
        .then(res => {
            logoutGoogle();
        } )
        .catch((error)=>{
          alert("error"+error.message);
        });

      }
    return (<>
    <GoogleOAuthProvider clientId={clientID}>
        <Avatar src={isAuthenticated?photo:"/broken-image.jpg"} onClick={toggleDrawer(true)} style={{cursor:'pointer'}}/>
        <Drawer open={showUI} anchor="right" onClose={toggleDrawer(false)}>
            <Container>
        {isAuthenticated&&<><div style={{textAlign:"center"}}><p>{name}</p><p>{email}</p></div></>}
        {!isAuthenticated?
            <GoogleLogin
            auto_select
            useOneTap
            clientId={clientID}
            onSuccess={credentialResponse => {
                decodeCredential(credentialResponse.credential);
            }}
            onError={googleLogoutResponse}
            />
            :<>
            <Button variant="outlined" onClick={logout}>Logout</Button>
            {/*<GoogleLogout 
            clientId={clientID}
            onLogoutSuccess={googleLogoutResponse}
            onFailure={googleLogoutResponse}
        />*/}
        </>
        }
        </Container>
        {isAuthenticated&&security.admin&&<>
        <Container>
        <div style={{textAlign:"center",marginTop:20}}>
        <Button variant="outlined" onClick={reloadSecurity}>Reload Security</Button>
        </div>
        </Container>
        </>}
        </Drawer>
        </GoogleOAuthProvider>
    </>)
}

export default AdminLogin_new;